<template>
    <div class="main">
        <div class="chart-wrapper">
            <Chart/>
        </div>
        <div class="card-wrapper">
            <Card :data="cardData"/>
        </div>
    </div>
</template>
<script>
export default {
    components:{
        Chart: () => import('@/components/dashboard/main-kpi/kplh/left/content.vue'),
        Card: ()=> import('@/components/dashboard/main-kpi/right-card.vue')
    },
    data() {
    return {
      cardData: {
        tiketSelesai: 10,
        responden: 20,
        sistem: 20,
        belumNilai: 250,
        sedangProses: 20,
        rejected: 5,
      }
    };
  }
}
</script>

<style scoped>
    .main {
        /* width: 85vw; */
        width: 80vw;
        height: 78vh;
        background-color: pink;
        overflow: auto;
        padding: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 1rem;
    }

    .chart-wrapper {
        width: 75%;
        box-shadow: -6px 5px 8px 0 rgba(0, 0, 0, 0.2);
        background-color: white;
    }

    .card-wrapper {
        width: 25%;
        /* border: solid 1px yellow; */
    }
</style>
